import { useNavigate } from 'react-router-dom'
import Button from '@/components/Button'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center py-20 font-avenir text-center bg-grey-98">
      <span className="type-display-1 text-theme-50">404</span>
      <h2 className="type-header-3 mt-2 text-grey-10">Page Not Found</h2>
      <p className="type-body-2 mt-2 text-grey-50">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <div className="flex gap-3 mt-8">
        <Button ghost round onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button round onClick={() => navigate('/submittals')}>
          Go to Home
        </Button>
      </div>
    </div>
  )
}
